/**
 * Helpers to let users enter an approximate Age instead of a full Date of Birth.
 * Equine ambulatory clients often only know roughly how old a horse is, so
 * "9 years old" maps to a DOB of Jan 1 of (current year - 9). Storage stays the
 * existing "YYYY-MM-DD" date string the DOB picker already produces — these are
 * pure UI conveniences with no schema or API-contract impact.
 */

/** Approximate DOB ("YYYY-01-01") for a given age in years, or '' if invalid. */
export function dobFromApproxAge(ageInput: string | number): string {
  const age = typeof ageInput === 'number' ? ageInput : parseInt(ageInput, 10);
  if (Number.isNaN(age) || age < 0 || age > 99) return '';
  const year = new Date().getFullYear() - age;
  return `${year}-01-01`;
}

/** Whole-year age from a "YYYY-MM-DD" DOB string, or '' if missing/invalid. */
export function approxAgeFromDob(dob?: string): string {
  if (!dob) return '';
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const monthDiff = now.getMonth() - d.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < d.getDate())) age--;
  return age >= 0 ? String(age) : '';
}
